var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('certificateDetail',{attrs:{"listData":_vm.officialData,"title":_vm.$t('1860'),"but":_vm.but,"authority":_vm.authority},on:{"handleItem":_vm.handleItem}})}
var staticRenderFns = []

export { render, staticRenderFns }